<template>
  <div class="has-logo">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrapClass="scrollbar-wrapper">
      <el-menu mode="vertical"
               :show-timeout="200"
               :default-active="activeMenu"
               :collapse="isCollapse"
               :background-color="variables.menuBg"
               :text-color="variables.menuText"
               :active-text-color="variables.menuActiveText"
               :unique-opened="true">
        <sidebar-item v-for="route in routes"
                      :key="route.name"
                      :item="route"></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import Logo from './Logo'
import variables from '@/styles/variables.scss'

export default {
  components: {
    SidebarItem,
    Logo
  },
  computed: {
    ...mapGetters(['sidebar', 'menus']),
    activeMenu() {
      const route = this.$route
      const { meta, name } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return name
    },

    routes() {
      return this.menus
      /* return this.$router.options.routes*/
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    variables() {
      return variables
    }
  },
  mounted() {}
}
</script>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue